module.exports = __webpack_public_path__ + "static/media/wechip-portal-badge3x.c2592686.png";